export enum FeatureToggle {
  EnhancedFulfillmentTestingCenter = 'rt_enhanced_fulfillment_testing_center',
  FtcBypassTesting = 'rt_ftc_bypass_testing',
}
